import React from 'react';
import PropTypes from 'prop-types';

import ModalModule from '../modal';
import CostCodes from './CostCodes.component';

const { Modal } = ModalModule;

export const ManageCostCodesModal = ({ modalId, data = {} }) => (
	<Modal
		modalId={modalId}
		className="common-cost-codes manage-cost-codes-modal"
		header="Manage Cost Codes"
		size="small"
		hideFooter
	>
		<CostCodes hideRightToolbarButtons callback={data.callback} />
	</Modal>
);

ManageCostCodesModal.propTypes = {
	// (Optional) Pass callback to handle after updating cost codes
	data: PropTypes.shape({
		callback: PropTypes.func,
	}),
};
